import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Modal from '../Modal';
import Map from '../Map/Map';
import Icon from '../Icon';

const ModalMap = ({ model, results, defaultZoom, options, showFullScreenButton }) => {
  const { longitude, latitude, zoom, apiKey } = model;
  const [init, setInit] = useState(false);
  const [open, setOpen] = useState(false);
  const mobToggle = document.querySelector('.CampsiteTop_mobileButton');
  const content = document.querySelector('.CampsiteTop_content');

  const openModal = () => {
    setInit(true);
    setOpen(true);
  };

  const closeModal = () => {
    setOpen(false);

    if (content) {
      content.classList.remove('active');
    }
  };

  const toggleModal = () => {
    setOpen(content.classList.contains('active'));

    if (!init) {
      setInit(true);
    }
  };

  useEffect(() => {
    if (!mobToggle || !content) {
      return;
    }

    mobToggle.addEventListener('click', toggleModal);

    return () => {
      mobToggle.removeEventListener('click', toggleModal);
    };
  }, []);

  return (
    <div className="ModalMap">
      <img
        src={`https://maps.googleapis.com/maps/api/staticmap?center=${latitude},${longitude}&zoom=${zoom}&size=320x600&maptype=roadmap&markers=color:blue|${latitude},${longitude}&key=${apiKey}`}
        className="ModalMap_image"
        loading="lazy"
        onClick={openModal}
      />
      <img
        src={`https://maps.googleapis.com/maps/api/staticmap?center=${latitude},${longitude}&zoom=${zoom}&size=465x262&maptype=roadmap&markers=color:blue|${latitude},${longitude}&key=${apiKey}`}
        srcset={`${`https://maps.googleapis.com/maps/api/staticmap?center=${latitude},${longitude}&zoom=${zoom}&size=1400x600&maptype=roadmap&markers=color:blue|${latitude},${longitude}&key=${apiKey}`} 800w,
                 ${`https://maps.googleapis.com/maps/api/staticmap?center=${latitude},${longitude}&zoom=${zoom}&size=465x262&maptype=roadmap&markers=color:blue|${latitude},${longitude}&key=${apiKey}`} 480w`}
        sizes="100vw"
        className="ModalMap_image ModalMap_image--only"
        loading="lazy"
        onClick={openModal}
      />
      {init && (
        <Modal open={open} onClose={closeModal}>
          <button className="ModalMap_button" onClick={closeModal}>
            <Icon name="PlusExpand" className="ModalMap_icon" />
          </button>
          <Map
            results={results}
            defaultZoom={defaultZoom}
            options={options}
            apiKey={apiKey}
            showFullScreenButton={showFullScreenButton}
          />
        </Modal>
      )}
    </div>
  );
};

ModalMap.propTypes = {
  model: PropTypes.object,
  results: PropTypes.array,
  defaultZoom: PropTypes.number,
  onCoptionslose: PropTypes.object,
  showFullScreenButton: PropTypes.bool,
};

export default ModalMap;
